ui.defaultTags = {
	button: {
		self: { name: "mambo-button" },
		button: { name: "button" },
	},
	buttonGroup: {
		self: { name: "mambo-button-group" },
	},
	buttonSVG: {
		self: { name: "mambo-button-svg" },
		button: { name: "button" },
	},
	calendar: {
		self: { name: "mambo-calendar" },
		body: { name: "mambo-calendar-body" },
		bodyContent: { name: "mambo-calendar-body-content" },
		bodyHeader: { name: "mambo-calendar-body-header" },
	},
	card: {
		self: { name: "mambo-card" },
		body: { name: "mambo-card-body" },
	},
	checkbox: {
		self: { name: "mambo-checkbox" },
		container: { name: "label" },
		input: { name: "input", attr: { type: "checkbox" } },
		span: { name: "span" },
		text: { name: "span" },
	},
	checkboxGroup: {
		self: { name: "mambo-checkbox-group" },
	},
	checkboxRadio: {
		self: { name: "mambo-checkbox-radio" },
		inputTag: { name: "input", attr: { type: "checkbox" } },
		label: { name: "label" },
		radioText: { name: "span" },
		radioSpanTag: { name: "span" },
	},
	combobox: {
		self: { name: "mambo-combobox" },
		container: { name: "mambo-combobox-container" },
		wrapper: { name: "mambo-combobox-wrapper" },
		input: { name: "mambo-input" },
	},
	datePicker: {
		self: { name: "mambo-date-picker" },
		wrapper: { name: "mambo-date-picker-wrapper" },
	},
	dialog: {
		self: { name: "mambo-dialog" },
		container: { name: "mambo-dialog-container" },
		button: { name: "mambo-dialog-button" },
		body: { name: "mambo-dialog-body" },
		header: { name: "mambo-dialog-header" },
		headerCenter: { name: "mambo-dialog-header-center" },
		headerLeft: { name: "mambo-dialog-header-left" },
		headerRight: { name: "mambo-dialog-header-right" },
		headerTitle: { name: "h3" },
		footer: { name: "mambo-dialog-footer" },
		wrapper: { name: "mambo-dialog-wrapper" },
	},
	dragDrop: {
		self: { name: "mambo-drag-drop" },
		dropText: { name: "mambo-drag-drop-text" },
	},
	draggable: {
		self: { name: "mambo-draggable" },
		draggable: { name: "mambo-draggable" },
	},
	dropdown: {
		self: { name: "mambo-dropdown" },
		container: { name: "mambo-dropdown-container" },
	},
	fileChooser: {
		self: { name: "mambo-file-chooser" },
	},
	grid: {
		self: { name: "mambo-grid" },
		colCell: { name: "mambo-col-cell" },
		body: { name: "mambo-grid-body" },
		header: { name: "mambo-grid-header" },
		headerTitle: { name: "mambo-title" },
		grid: { name: "mambo-grid" },
		row: { name: "mambo-data-grid-row", attr: {} },
		text: { name: "mambo-text" },
		tileItem: { name: "mambo-tile-item", attr: {} },
		tiles: { name: "mambo-tiles" },
	},
	input: {
		self: { name: "mambo-input" },
		container: { name: "mambo-input-container" },
		input: { name: "input", attr: { type: "text" } },
		errorIcon: { name: "i" },
		successIcon: { name: "i" },
		errorText: { name: "mambo-input-error-text" },
	},
	listbox: {
		self: { name: "mambo-listbox" },
		container: { name: "mambo-listbox-container" },
		item: { name: "mambo-listbox-item" },
	},
	listMenu: {
		self: { name: "mambo-list-menu" },
		container: { name: "mambo-list-menu-container" },
		wrapper: { name: "mambo-list-menu-wrapper" },
		body: { name: "mambo-list-menu-body" },
		title: { name: "mambo-list-menu-title" },
		subtitle: { name: "mambo-list-menu-subtitle" },
	},
	mapbox: {
		self: { name: "mambo-mapbox" },
		container: { name: "mambo-mapbox-container" },
		currentPoint: { name: "mambo-mapbox-current-point" },
	},
	pagination: {
		self: { name: "mambo-pagination" },
		container: { name: "mambo-pagination-container" },
		button: { name: "mambo-pagination-button" },
	},
	percentage: {
		self: { name: "mambo-percentage" },
		bar: { name: "mambo-percentage-bar" },
		text: { name: "mambo-percentage-text" },
	},
	player: {
		self: { name: "mambo-player" },
		controls: { name: "mambo-controls" },
		time: { name: "mambo-time-stats" },
		player: { name: "video" },
	},
	radio: {
		self: { name: "mambo-radio" },
		container: { name: "label" },
		input: { name: "input", attr: { type: "radio" } },
		span: { name: "span" },
		text: { name: "span" },
	},
	radioGroup: {
		self: { name: "mambo-radio-group" },
	},
	rating: {
		self: { name: "mambo-rating" },
		empty: { name: "mambo-rating-empty" },
		emptyStar: { name: "mambo-rating-empty-star" },
		hover: { name: "mambo-rating-hover" },
		hoverStar: { name: "mambo-rating-hover-star" },
		selected: { name: "mambo-rating-selected" },
		selectedStar: { name: "mambo-rating-selected-star" },
	},
	search: {
		self: { name: "mambo-search" },
		inputContainer: { name: "mambo-search-input-container" },
		wrapper: { name: "mambo-search-wrapper" },
	},
	slideout: {
		self: { name: "mambo-slideout" },
		body: { name: "mambo-slideout-body" },
		header: { name: "mambo-slideout-header" },
		overlay: { name: "mambo-slideout-overlay" },
	},
	slider: {
		self: { name: "mambo-slider" },
		handle: { name: "mambo-slider-handle" },
		selection: { name: "mambo-slider-selection" },
		step: { name: "mambo-slider-step" },
		stepLarge: { name: "mambo-slider-step-large" },
		stepsContainer: { name: "mambo-slider-steps-container" },
		track: { name: "mambo-slider-track" },
		wrapper: { name: "mambo-slider-wrapper" },
	},
	switch: {
		self: { name: "mambo-switch" },
		container: { name: "mambo-switch-container" },
		handle: { name: "mambo-switch-handle" },
		off: { name: "mambo-switch-label-off" },
		on: { name: "mambo-switch-label-on" },
		text: { name: "mambo-switch-text" },
	},
	tab: {
		self: { name: "mambo-tab" },
		content: { name: "mambo-tab-content" },
		body: { name: "mambo-tab-body" },
		tabs: { name: "mambo-tabs" },
	},
	textarea: {
		self: { name: "mambo-textarea" },
		textarea: { name: "textarea", attr: {} },
		span: { name: "span" },
		buttonsContainer: { name: "mambo-textarea-buttons-container" },
		iconsContainer: { name: "mambo-textarea-icons-container" },
		footer: { name: "mambo-textarea-footer" },
		iconRequired: { name: "i" },
		textRequired: { name: "mambo-textarea-text-required" },
		containerUp: { name: "mambo-textarea-container-up" },
		containerDown: { name: "mambo-textarea-container-down" },
	},
	timePicker: {
		self: { name: "mambo-time-picker" },
	},
	toaster: {
		self: { name: "mambo-toaster" },
		button: { name: "mambo-toaster-button" },
		body: { name: "mambo-toaster-body" },
		buttonContainer: { name: "mambo-toaster-button-container" },
		iconContainer: { name: "mambo-toaster-icon-container" },
		wrapper: { name: "mambo-toaster-wrapper" },
	},
	tooltip: {
		self: { name: "mambo-tooltip" },
		body: { name: "mambo-tooltip-body" },
	},
	treeView: {
		self: { name: "mambo-tree-view" },
		group: { name: "mambo-tree-view-group" },
		icon: { name: "icon" },
		item: { name: "mambo-tree-view-item" },
		itemIn: { name: "mambo-tree-view-item-in" },
		itemTop: { name: "mambo-tree-view-item-top" },
	},
	template: {
		self: { name: "mambo-template" },
	},
	videoPlayer: {
		self: { name: "mambo-video-player" },
	},
};

ui.class.Tags = class Tags {
	constructor() {
		this.m_tags = {
			default: ui.defaultTags,
		};
	}

	getTags(context) {
		if (context && context.name && context.component) {
			if (context.name in this.m_tags) {
				return this.m_tags[context.name][context.component];
			}
		}
	}

	addTags(context) {
		if (!context || !context.name || !context.tags) {
			throw "Tags() you invoked addTags() but failed to define the tags name.";
		}

		if (this.m_tags[context.name] && !this.m_tags[context.override]) {
			throw `Tags() you have attempted to override the tags name ${context.name}. Please add the property 'override:true' to succesfully override the tags.`;
		}

		this.m_tags[context.name] = context.theme;
	}
};

ui.tags = new ui.class.Tags();
